import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';


type APIPayload = {
  id: string;
  x_api_key?: string,
  products_api_url?: string,
  order_details_by_id_api_url?: string,
  get_orders_by_email_api_url?: string,
  cart_local_storage_key?: string,
  cart_url?: string,
  checkout_url?: string,
};

export const updateCustomApiCaller = async (payload: APIPayload) => {
  const {id, ...rest} = payload
  try {
    const response = await Axios.put(`/custom_api_call_router/${id}`, rest);
    return response.data;
  } catch (error: any) {
    throw error?.response?.data;
  }
};

export const useUpdateCustomApiCaller = () => {
  return useMutation({
    mutationFn: (payload: APIPayload) => updateCustomApiCaller(payload),
    onSuccess: (data) => {
      toast.success('Web settings created successfully');
      console.log({ data });
    },
    onError: (error) => {
      toast.error('Unable to create web settings.', {
        description: error.message,
      });
      console.log({ error });
    },
  });
};
